// student-frontend/src/components/VerticalLayout/manual.tsx

import React, { useState, useRef, useEffect } from "react"
import styles from "./manual.module.css"

type Props = {}

export const Manual = (props: Props) => {
    const [open, setOpen] = useState(false)
    const wrapperRef = useRef<HTMLDivElement | null>(null)

    const toggleMenu = () => {
        setOpen(prev => !prev)
    }

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                wrapperRef.current &&
                !wrapperRef.current.contains(event.target as Node)
            ) {
                setOpen(false)
            }
        }

        if (open) {
            document.addEventListener("mousedown", handleClickOutside)
        } else {
            document.removeEventListener("mousedown", handleClickOutside)
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
        }
    }, [open])

    const STUDENT_APP_MANUAL =
        "https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/manuals/Student_User_Manual_V2.pdf"

    const STUDENT_ONLINE_SESSION_MANUAL =
        "https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/manuals/Student Online Session User Manual V1-1.pdf"

  return (
        <div
            ref={wrapperRef}
            className={`position-relative ${styles.menuItem} ${styles.manual}`}
        >
            {/* Trigger (icon + label) */}
            <div
                className="d-flex flex-column align-items-center cursor-pointer mt-3"
                onClick={toggleMenu}
            >
                <i className="fas fa-book-open font-size-20"></i>
                <div className="font-size-12">Manual</div>
            </div>

            {/* Dropdown menu */}
            {open && (
                <div className={styles.dropdownMenu}>
                    <a
                        href={STUDENT_APP_MANUAL}
                        target="_blank"
                        rel="noreferrer"
                        download
                        className={styles.dropdownItem}
                    >
                        Student app manual
                    </a>
                    <a
                        href={STUDENT_ONLINE_SESSION_MANUAL}
                        target="_blank"
                        rel="noreferrer"
                        download
                        className={styles.dropdownItem}
                    >
                        Student online session manual
                    </a>
                </div>
            )}
        </div>
    )
}